<div role="main" *ngIf="!isUrlDisabled && !showLoader">
    <app-header [isDashboard]="true"></app-header>
    <form [formGroup]="referenceForm" style="box-sizing: content-box;" class="referenceheader">
        <div class="row mt-5p">
            <h2 aria-level="2" id="section1" class="welcome-text">Welcome to FileCapture
                <sup ngbTooltip="Please locate the Reference ID within the letter you received to add into the text field and then click Enter."
                    #t="ngbTooltip" (click)="t.open()" triggers="manual"><span class="fs-16">
                        <i class="fa fa-info-circle" aria-hidden="true"></i></span></sup>
            </h2>
            <div class="col-xs-12 col-sm-5 col-md-3 col-lg-3 fcLoginInputDiv">
                <input type="text" name="referenceNumber" maxlength="60" formControlName="referenceNumber" class="input"
                    id="Reference-id" placeholder="Please Enter a Reference ID">
            </div>
            <div class="col-xs-12 col-sm-3 col-md-3 col-lg-3 fcLoginButtonDiv">
                <button class="btn-enter" id="dashboardButton" type="submit" (click)="Next()"
                    [disabled]="referenceForm.invalid"
                    [ngbTooltip]="referenceForm.invalid ? 'Please enter a valid Reference ID to proceed' : ''"
                    [tooltipClass]="'tooltip-disabled'">Enter</button>
                <button class="btn-clear" id="dashboardButton" type="button" (click)="clear()"
                    [disabled]="referenceForm.invalid">Clear</button>
            </div>
            <div *ngIf="error" class="error-message-container"><span class="text-danger">The Reference ID entered is not valid, please click on the Clear button and try again.</span></div>
        </div>
    </form>
    <div class="fcLoginFooter">
        <div class="fcLoginFooterDiv">
            <app-footer></app-footer>
        </div>
    </div>
</div>

<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="large" color="#fff" type="ball-scale-multiple"
    [fullScreen]="true">
    <p style="color: white">Please do not Cancel or Refresh page</p>
</ngx-spinner>

<div class="container" role="main" *ngIf="isUrlDisabled && !showLoader">
  <div class="row main-home py-0">
    <div class="col-md-12">
      <h1 role="heading" aria-level="1">Please verify the URL that you are attempting to access.</h1>
    </div>
  </div>
</div>
  